import Base from '../base.js';

export class Assess extends Base {
    constructor(containerId, options){
        options.mode = 3;        
        super(containerId, options);
    }
}